export var Headers;
(function (Headers) {
    Headers["RequestId"] = "x-request-id";
    Headers["AuthToken"] = "x-auth-token";
    Headers["AdminToken"] = "x-admin-token";
    Headers["LogzCSRFToken"] = "x-logz-csrf-token";
    Headers["TracingAccountId"] = "x-tracing-account-id";
    Headers["GrafanaPageType"] = "x-gf-page-type";
    Headers["GrafanaDashboardUid"] = "x-gf-dashboard-uid";
})(Headers || (Headers = {}));
//# sourceMappingURL=headers.enum.js.map